import { createSlice } from "@reduxjs/toolkit";
import getList from "../Actions/GetLicenseApiKeys-Action";
const initialState = {
  apiKeys: [],
  isLoading: false,
  status: "",
  isLoaded: false,
  lastEvaluatedkey: "",
  loadMore: false,
};
const LicenseApiKeys = createSlice({
  name: "LicenseApiKeys",
  initialState,
  reducers: {
    addApiKey(state, action) {
      if (!state.isLoaded) {
        return { ...state };
      }
      let obj = {
        api_key: action.payload?.api_key || "",
        id_type: action.payload?.id_type || "",
        api_key_name: action.payload?.api_key_name || "",
        status: action.payload?.status || "",
        created: action.payload?.created || "",
        id: action.payload?.id || "",
        restaurant_id: action.payload?.restaurant_id || "",
        restaurant_name: action.payload?.restaurant_name || "",
      };
      let finalApiKeys = [obj, ...state.apiKeys];
      return { ...state, apiKeys: finalApiKeys };
    },
    deleteApiKey(state, action) {
      if (!state.isLoaded) {
        return { ...state };
      }
      const { api_key } = action.payload;
      let index = state.apiKeys.findIndex((item) => item.api_key === api_key);
      let finalApiKeys = state.apiKeys.filter((item, i) => i !== index);
      return { ...state, apiKeys: finalApiKeys };
    },
    changeStatus(state, action) {
      if (!state.isLoaded) {
        return { ...state };
      }
      const { status, api_key } = action.payload;
      let index = state.apiKeys.findIndex((item) => item.api_key === api_key);
      let obj = { ...state.apiKeys[index], status };
      let finalApiKeys = [...state.apiKeys];
      finalApiKeys[index] = obj;
      return { ...state, apiKeys: finalApiKeys };
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },

    setIsLoaded(state, action) {
      state.isLoaded = action.payload;
    },
  },
  extraReducers: {
    [getList.pending]: (state, action) => {
      if (state.lastEvaluatedkey === "") {
        state.isLoading = true;
      } else {
        state.loadMore = true;
      }
    },
    [getList.fulfilled]: (state, action) => {
      if (action.payload.api_keys) {
        let newArr = [];
        newArr = action.payload.api_keys;
        state.apiKeys = state.apiKeys.concat(newArr);
        state.lastEvaluatedkey = action?.payload?.lastEvaluatedkey
          ? action.payload.lastEvaluatedkey
          : "";
      } else {
        state.status = "Something went wrong😥";
      }
      state.isLoading = false;
      state.loadMore = false;
    },
    [getList.rejected]: (state, action) => {
      state.isLoading = false;
      state.loadMore = false;
      state.status = action.error.message;
    },
  },
});

export const licenseApiKeysActions = LicenseApiKeys.actions;

export default LicenseApiKeys.reducer;
